import { useAtom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

const notShowMobileWarningAtom = atomWithStorage(
  'notShowMobileWarning',
  false,
  undefined,
  { getOnInit: true }
);

export const useNotShowMobileWarning = () => useAtom(notShowMobileWarningAtom);
